module.exports = __webpack_public_path__ + "static/media/TabIcon.5b1ae7b9.svg";